export class InspectionPointSvgPosition {
  x: number;
  y: number;
  isDisplayed: boolean;

  loadFromJson(data: any) {
    this.x = data.x;
    this.y = data.y;
    this.isDisplayed = data.isDisplayed;
  }
}
